/**
 * 斷線期間的訂單推播補不回來，只能在重連成功後重取。首次連線由進頁的載入負責。
 */
export function shouldResyncOrdersAfterReconnect(missedPushWindow, pathname) {
	return (
		missedPushWindow === true && pathname?.startsWith('/order-manage') === true
	)
}

export function captureOrderListSnapshot(orders) {
	return new Map(orders.map(order => [order.id, order]))
}

/**
 * 將伺服器快照合併回目前畫面，同時保留請求期間由 WebSocket 更新的訂單。
 * 既有訂單採原物件更新，避免展開狀態與彈窗持有的參照失效。
 */
export function mergeOrderListSnapshot({
	currentOrders,
	requestStartOrders,
	serverOrders,
	busyOrderIds = new Set(),
}) {
	const currentById = new Map(currentOrders.map(order => [order.id, order]))
	const serverIds = new Set(serverOrders.map(order => order.id))
	const addedOrders = []

	const preservedLocalOrders = currentOrders.filter(order => {
		if (serverIds.has(order.id)) return false

		const requestStartOrder = requestStartOrders.get(order.id)
		return (
			!requestStartOrder ||
			requestStartOrder !== order ||
			busyOrderIds.has(String(order.id))
		)
	})

	const mergedServerOrders = serverOrders.map(serverOrder => {
		const currentOrder = currentById.get(serverOrder.id)
		if (!currentOrder) {
			const addedOrder = { ...serverOrder }
			addedOrders.push(addedOrder)
			return addedOrder
		}

		const requestStartOrder = requestStartOrders.get(serverOrder.id)
		if (!requestStartOrder || requestStartOrder !== currentOrder) {
			return currentOrder
		}

		Object.assign(currentOrder, serverOrder)
		return currentOrder
	})

	return {
		orders: [...preservedLocalOrders, ...mergedServerOrders],
		addedOrders,
	}
}
